// src/pages/Relatorios.js

import React from "react";
import AdminLayout from "../components/AdminLayout";
import DataTableRelatorios from "../components/DataTableRelatorios";

function Relatorios() {
  const data = [
    {
      id: 1,
      number: "001401",
      subject: "Design Works",
      client: "Carlson Limited",
      vat: "2024.18911.18923.0.029581",
      created: "27 Out 2024",
      status: "Paid",
      statusClass: "bg-success",
      price: "R$887",
      link: "invoice.html",
    },
    {
      id: 2,
      number: "001402",
      subject: "UX Wireframes",
      client: "Adobe",
      vat: "2024.18911.18923.0.029581",
      created: "12 Out 2024",
      status: "Pendente",
      statusClass: "bg-warning",
      price: "R$1200",
      link: "invoice.html",
    },
    // Outros dados...
  ];

  return (
    <AdminLayout>
      <DataTableRelatorios title="Relatórios" newButtonRoute="./novo" data={data} />
    </AdminLayout>
  );
}

export default Relatorios;